import deleteIcon from '@/assets/icons/deleteIcon.svg'
import { Loader } from "@thdinc/hpf-shared";
import React, { FC, useState } from "react"
import { FaPlus } from "react-icons/fa"

interface Mixers {
    id: string,
    type: string,
    name: string,
    image: string,
    quantity: number,
    size: number,
    price: number,
    status: string,
    created_at: string,
    updated_at: string,
    store_id: string
}

interface MixersCardProps {
    mixers: Mixers[];
    setMixersIsOpen: (open: boolean) => void;
    isLoading?: boolean;
    onRemove: (id: string, type: string) => void;
}

const MixersCard: FC<MixersCardProps> = ({ mixers, setMixersIsOpen, isLoading, onRemove }) => {
    const [searchQuery, setSearchQuery] = useState("");

    const filteredMixers = mixers.filter(mixer =>
        mixer.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div className="bg-white rounded-3xl p-3 px-5">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                <h1 className="font-semibold text-xl">Mixers/Syrups</h1>
                <div className="flex flex-row items-center gap-2 w-full sm:w-auto">
                    <input
                        type="search"
                        placeholder="Search by Name"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="w-full sm:w-auto min-w-48 md:min-w-64 px-4 py-2 rounded-full bg-[#F7F8FA] focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                    />
                    <div onClick={() => setMixersIsOpen(true)} className="bg-[#F7F8FA] inline-block p-3 rounded-full cursor-pointer">
                        <FaPlus size={17} />
                    </div>
                </div>
            </div>
            <div className="flex flex-row flex-wrap gap-8 mt-8">
                <>{isLoading ? <Loader color="bg-red-500" /> : filteredMixers.map((mixer, index) => {
                    return (
                        <div key={index} className="flex flex-row items-center relative group flex-wrap">
                            <div className='flex flex-row justify-center items-center gap-1'>
                                <div className="bg-[#FFCBB3] w-4 h-4 rounded-full" />
                                <h1 className="font-medium text-sm break-all">{mixer.name}</h1>
                            </div>
                            <button
                                onClick={() => onRemove(mixer.id, 'mixers')}
                                className="absolute right-[-20px] rounded-full opacity-0 group-hover:opacity-100 transition">
                                <img src={deleteIcon} alt="delete" />
                            </button>
                        </div>
                    )
                })}</>
            </div>
        </div>
    )
}

export default MixersCard